import { useEffect, useState } from "react";
import styled from "styled-components";
import Countdown from "react-countdown";
import { Button, CircularProgress, Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

import * as anchor from "@project-serum/anchor";

import { LAMPORTS_PER_SOL } from "@solana/web3.js";

import { useAnchorWallet } from "@solana/wallet-adapter-react";
import { WalletDialogButton } from "@solana/wallet-adapter-material-ui";

import {
  CandyMachine,
  awaitTransactionSignatureConfirmation,
  getCandyMachineState,
  mintOneToken,
  shortenAddress,
} from "./candy-machine";

const whitelist = [
"3oMZfqDZYY54LYRjvVAeYT35P1Vwo1Wea61BGe5gS3wt",
"95J6N2Sz5aLT1kuEuWwNspbgJgLob8r8k6E846XeRwq1",
"EdEo2b7BSvT72ABUiuLjqgdrZoEm39bZxym3uKr8rrd7",
"EBLyVjie81BHWm59qyoRwEdRRXrCaCHrf8An5Hq8spQJ",
"GWbGnfkQCcneKBA8pPqJrhsuf4yss92ea2gCfM53Phzj",
"HekXqjAAuwYVKYmTjAt8kq9u3iJT3EjL6qZCCxNKdMet",
"8g9K9tCkhMfVyg9KPUh9eXKSRizUxEjxji6HT3RPoD2W",
"7LBehehoPeKubq5sNNhGcCwXRpydyVtCp4aSe3N3NeTy",
"ELesmbvH8cBNLgcBwQ3faf6RiX2x8GhYNfbgZgzpazW7",
"4xzotCppT2UE1joXnfci6UB9kkWusoWQSocZji3BkRXj",
"7hwKZWevE2rzhfwYbquvFuGbTbTHNucSYh4rFg5QtCPA",
"EnNZCTw1p4N2Edi8Nivo4eqgUrBhUKgpfmZ888HK8r8v",
"FLB6xHpvjvgqjfmcNHtepLEAFvgq71zq5Nds22acS9uh",
"APKseTBxhcV7z4fYMrjeYbUQ3X1UMCyhoxoP6EKkHSBU",
"7EjCXmjskjugYCUCCCKbwepbxyKndoepZrWEz19UkYgV",
"ASp12B17BGG4dmG3bJ78R3L53SjxFKeUskb1bK6DYivE",
"6R9y2RtjLC2Z2xYNFDXKXXMgLpDgAmA4hrs5G1uzQAZS",
"8gM1FvXRpZETw848vKJZLaGAyBDv6iUmuDMd4D4hGybt",
"7DrtcjpsoJmBi5fVmE2s5ukBFW9ge5t8UGz8aJF6ryih",
"EEH6g9tdvtyJDLBZWNVBmVMooXgcjtKkU3hX6N6RzyLh",
"Dgq4C49Xw8mXJe5BqVz8mGcwNrHgnQRoQAEw6yeN5FdB",
"21RGLc3KagSjjN9PQ2xEdJFeE8qgPSQ2yRHtJtGri3A8",
"6FkJhcmuGmJMRovuebvEiM17gvhEWtVADYYHPr44n3qW",
"YvpuNLEqcy5zUivmKFY8tCSBedC3FstxihNV9nYweZQ",
"D6gJfnmkNgsR4DLsr9uSoXyGkY3JxodC3fpJQGnHpVw6",
"74tD5HSzeYsD4ShsBA3ySbt7tcFPc23GD8Pr693YxrnB",
"0xF43638610f86dEC54141e3AF07f0254385e39F55",
"GLreZN5tEzPFoJVcmjEmzHdAbYcZB41rFPeBNqpckFKH",
"HsnNmbd8eCtqSqqcYvEbQSx6UDKP49q159qbs6KoU9Em",
"9DY8ZjfGC8eQH4Wfr9EWfazpPn5P1aKxx4Hq8zALv8kN",
"AB59nYxxxhR7dHcYHPv6rur4p1yCmjnvg3ngg2AuX7oP",
"69zTm2rUSikJuyNKLEag2pHKgqJMVGmV97D3XAN46K5u",
"BVWCZ61p9S72WXWDxSX82BNeL63VBf4sRVe6uRTzfUq9",
"EwdUT8fRRMo41sLBGQGwz4hXdRZqBqfYaQQ14v97urro",
"0xc584f212ff9108f13a9dceb8c88fa7652eee697c",
"3pSNQT1b36TgMu9Nz5wfvgBiNqH5wizBP8G9jusUq24e",
"CMz1pHiaokKVs5feBeyUkt9VbNz7qVE3uhzh5B9onuyP",
"3aUUKjbKgF8WzeZzpSzcpoEjwW7QfDZqSExUEGqLa76r",
"FNxVeeZdyypAtoxr35mUVWohkJHbyxog4sgRphDv48Cp",
"3R8mopyVzcHkbEZnBQ71bM5VjrXLsZqCcpysSua6ii9y",
"2q2N417PrM1rVxRxZyN7oTsdMPZwdJmD8EbvHSBgYAF2",
"E2gYc1M2jMoGzXPrLT4rSGW8TaDrTx7fxoaDtPBartKQ",
"GWNmwubLdaE3ZqJMuiTive6GMwJxpYUAMjcC7MwRoVFz",
"D3cPotHJyRwBYuHY8rFTE77WkQVSJXoqGFzZxuSQqxXE",
"3KP7pkuSVfsVxUu7EUHMapADyzjVipKHn6iNeXoRAG4q",
"Gc23Gj8hycemHFjgPe6Fgoo3axvURWMTneg7vSWrGLYC",
"FdrnpJGopagDacfxbReRBFpmA1swkEHTDXs5AzyiDioQ",
"8qyfZCDDA82qtwiLdSTuxD1BDHPUCePxGFMRSHC5ug4G",
"Gv6csLt2gXAgyJxn795kJupnBH3qm5xcRKuT77QdVUs6",
"H5FpiDqXKNDDmhxYKNhNFa1HkMoXBpeMgwuSu74AXBRK",
"1DUdpCi3CwHvhmLLYUwfwB7bubinWdZYeqNdLj6dmxy",
"BBDR7rgAh3HRDbt3ypXkNWvNgQeHBuQGm5KxaS9Qe2ye",
"FCB9z93qHJUxcuiu1YrsaLBGVAGueuMKx5juK24AUb3v",
"4YMahptB7No5MEKZFKXaif1P33LHJ6dRiDL3r7Q9GHEo",
"D4t1Tx5cy9braSL2FdpHotqUFUEEyfHtU3bzKmaEuc2C",
"ApCbem7XmTf9nt6As9Zs2VYK5GLVss2RpyvxBoks7Uss",
"EBTTVFwMq43xCMVAaQfq4UfBmDzQfrP3ewSiDqcPSmhN",
"CGJbEecuW5E5CzacA8Lxisrj8BVLrsgTyk1TVdZ8j13F",
"4Yvjvz99DL8honJ3ixstGazF2teCStL76PQThPkEeLRi",
"8SEK4tFGpwmAURAPYdH3YK4Gkg92f8ZFj4KHaNeBdzRq",
"2oWdVoSLuWY1VLffcEtDD4znrykJNedYmBQcyy62AsLg",
"B8uo5MeWS3xsg4nN1u9QFpe2BSPodkJdiHrSxVTgiBti",
"6mUVbA4RSDXVQnWo93tfNCiDHHwDEH8L2GfvAsU48DbA",
"CQLs9MmasQxKjPJsjYVCkPRt6XYDDJKEcb5rD5bE6NCm",
"8oQoWpNcQ4uSBXQs9qnWbhANjMFp49T5RMYjRs2kJi1q",
"H1KgVyes1KHKugN1vU5PLeYrN2dBX1Q1HU7KvKBkFTct",
"7mhKpC4VMHZWUgqcRHaD2CLwR5zBZLR12uWkLiEgM55b",
"HXo1tfmQ7wPb9FZwXD7DZVEDueVtxFiTzh3yK5RLV5Pg",
"34CEuFjW7PYZAEP7ynb1fLNdF8bHPwgD9KtYccmgjpWR",
"91Wuqdn5v3RW6E78XiZs1zdkYg8Xdop9LDcsp7Yefkt7",
"C7ZVFUqEJ6xqREYVr1NmQq9EW5MpcSSbDq4GCapjKBs4",
"Esqsq3UPd6v6TvCjAZn3Vk1HXJjzEVTcFbCaNWomJNme",
"Eo2WSeYbn3P3NQBxrDyptdgzoRMxZ1aGCnvfAYJyNhTi",
"HkbpGSot9k4oM3XhVvZ4x6uF8rd8KJ2hKRkpyuxDbeBx",
"9UfHmfMjrEQ6oEzHU2HJX4NHNrnDFVv6dfmaHKCSihLR",
"GMnCbQYyVFgGXKGFqqc3kf7iUWgJqXgvt2UERHu19AvT",
"GXjig5H7mDNsdvSN1tzTRkWEyxnQaxnPhaDpWmALsab3",
"A76467CA898A6189F7a29Bf67FeFDfe050",
"CXAWYJQzC8LwhAMLRoAdA7xQEAahqZzAAk63MWf48PSh",
"86Dmd98KwhJ3oBuzCkcKJ1F1PduPSkadR4dE27tDRJPS",
"DTh5imcQXoWVE4LejSUsPKZuYPWUUg5KQJkKbRbkiPjD",
"4ujQzQGQg9EadHXK8f2SEQkpCuujaWxbaQYkZBrCJKf1",
"6h8AcHFEwB6xrwgWKe2QLmyTU3fMF8ut6Ew6Q6xbAcH3",
"E3fe7g5NuYDUVvo8p4fkMvcy1PhKHJix6MEHj8DpipHw",
"9FiKgn4mxLwuNwi3sSgsWCmGxMbdaZ1jr1df2bZhkmdU",
"9g4kZtMRA7R8n8K5fg86CT6vKByxqDiabjNnf1DZEFuU",
"9xpHSvvQMfNAPxwEW2YPYZugTwGPy9unWnhPq8a3eXsq",
"E2MKRxMA1m2tQJautvEHptSJAYkCweEk2Q1jDnzht8ts",
"81mE2ScLFv4GZNhYuhBzGJ56z7Wcw4TA7yCZkh4Y3HUD",
"P1nfcCWeL7WDkUDTvGNva3ygZn983peQdVRaiJ9AfJF",
"59rozoMHuVtmQXeozMQstZQLnr9fMUc8ciEntqxQ5HYh",
"2cdv15mgCd3Jt1ka7Jz58fEweXMToqPmb1VYZ1g3oYQ5",
"5Xz4UTv9MAEtigtTAfBZjZACWj7JqkDWGbTyzexm7Lk1",
"5qgUCqgtoZVRayT7uwBhjfWXSRXFegehAiGZkvafR52B",
"6Wn6qfwKjEHEws66zaczYEBS63hp7jEkhQ5tJSERozsG",
"242izv9KxkyvvAq6AGSzAmJyrhVc8bcf6sVLyMJMuVLw",
"9KLzyCfoZRyxoprVHv8sab3FJkH2PwaDEU9EyEHXBRC3",
"3MNriUi5s4WcaPGz9gj4LFokSVgowXbFnNrU5KBepE9S",
"GWbGnfkQCcneKBA8pPqJrhsuf4yss92ea2gCfM53Phzj",
"4HmUDjZ2Habb1i9Vf12NVYq7tymP3JsWM72XH8uuYwYt",
"65G5VRZmZFyFkdXfkN2K7ufXf1cvGWFAZrSahn5JHwMq",
"8qy35357gQrXJutUj55KFPeKF4FZnHm2wiz78bzee9ye",
"CSoYDybSKcF37XBwRWCKAQZtFcNfK13XtFcsA3C5t2za",
"9MUFfC6EYMS4b7R8UW5e4xvCdyQadzGwuQFgfsg3LEgV",
"5C7DdCTZ1YsvFcDWix9gSEiykQtqi7sE4e5qVMfzzmLA",
"7nFfjPX7oFh7zb4ujewPHAkMebDkz7RHEGLSQKwtSNoH",
"6bFFaZcn9E9CH6wn7sZAUpkmis5JgrhdRpvMhmbAkFrF",
"2KD9GNYyHiyHAsKcaDc19N32tnMuxi8zQGkYyyMh2X5u",
"DgtUivTNFHX2jYbxuk8kpUFDdUCR2QB48UeScNoXFF5A",
"A9wsU7Ls7bsnWNRbsvVKgS2bkFJByGnMGFoXsVHYowqH",
"75ZmhB5Xka6JEtDaTNmC8QwdZdTDYuQqje5XjqtykyFj",
"DHnKWid6bA6fYjEGwtHZpNpc9i5Qng9V53PvCnAvnn98",
"5n8qhJjgvCjiK8DhttDMQoAq8FNJgtQe3cCZp9PjsNB",
"FCB9z93qHJUxcuiu1YrsaLBGVAGueuMKx5juK24AUb3v",
"2DmZ7hhWrhJ3oy9YAbr1MBSjM9ckR3kCuCo3QBetD7qu",
"Dcn4k9PPisnvVvATzS511WeSLvocgwRUU9NtG9xg4jpB",
"0x397F694ff30b36EE0a18ee36DdE6C47F1Efcf84a",
"2wtGJYCexgPW3hzJ3fJ7ZsxhBp4XTGdTh5JRpb7KgW7f",
"GmenjQXCUkfBfp7EARJxGmEdBWnd7zFzMUAyKWVQgP3T",
"CcERuovGjqdE5Ap5uDCo59zf8e26u5bdrhXKdEPFHCxf",
"8oQoWpNcQ4uSBXQs9qnWbhANjMFp49T5RMYjRs2kJi1q",
"A94V62a5koLhmgD7h6pyfksxnz2caxwqCx95xwZZ2ttR",
"2HeBrGsNnsCf8fjZtKV4ta4UATxvXxGC1n3FjQERs1kN",
"GMqQpKDEW1g7nN1qVPY1oShwexBJB1qMpsWEVoicWaFv",
"4M5WxG1PtQPtwJqHYreY3911eJgRwdRf5ZfchKZgyDaW",
"GbkYegethjjLfSbK1oJYHZCd6xdK91cFEr1BbeRqiDKS",
"9rEeQgf1yJmSr8bBrj1P3FDBj7bgkHHhFkPjHpae4pww",
"EKsW1inyULeBvpS1mz2AY9qbpo4ys1coSh4iqfoXZ5PD",
"8HMTWUGT3Q2TQuGYLfHqTaQc9LRFfzdqXyVRF5HzVoWM",
"CFdjuEW89jnuRkNxoRzGXNcgwZUxifv5GuKiabz8h13i",
"DhvvLukRDQXY1ebe9rk64myBujiB45s8QYxuSUW1qJMW"];

const ConnectButton = styled(WalletDialogButton)``;

const CounterText = styled.span``; // add your styles here

const MintContainer = styled.div``; // add your styles here

const MintButton = Button; // add your styles here

export interface HomeProps {
  candyMachineId: anchor.web3.PublicKey;
  config: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  startDate: number;
  treasury: anchor.web3.PublicKey;
  txTimeout: number;
}

const Home = (props: HomeProps) => {
  const [balance, setBalance] = useState<number>();
  const [isActive, setIsActive] = useState(false); // true when countdown completes
  const [isSoldOut, setIsSoldOut] = useState(false); // true when items remaining is zero
  const [isMinting, setIsMinting] = useState(false); // true when user got to press MINT

  const [alertState, setAlertState] = useState<AlertState>({
    open: false,
    message: "",
    severity: undefined,
  });

  const [startDate, setStartDate] = useState(new Date(props.startDate));
  const [itemsRemaining, setItemsRemaining] = useState(0);

  const wallet = useAnchorWallet();
  const [candyMachine, setCandyMachine] = useState<CandyMachine>();

  const [mintButtonIsHidden, setMintButtonIsHidden] = useState(true);
  const [presaleMintSucceeded, setPresaleMintSucceeded] = useState(false);
  const [isWhitelisted, setIsWhitelisted] = useState(false);

  const onMint = async () => {
    try {
      setIsMinting(true);
      if (wallet && candyMachine?.program) {
        const mintTxId = await mintOneToken(
          candyMachine,
          props.config,
          wallet.publicKey,
          props.treasury
        );

        const status = await awaitTransactionSignatureConfirmation(
          mintTxId,
          props.txTimeout,
          props.connection,
          "singleGossip",
          false
        );

        if (!status?.err) {
          localStorage.setItem('minted_status', 'succeeded');
          setAlertState({
            open: true,
            message: "Congratulations! Mint succeeded!",
            severity: "success",
          });
          setPresaleMintSucceeded(true);
        } else {
          setAlertState({
            open: true,
            message: "Mint failed! Please try again!",
            severity: "error",
          });
        }
      }
    } catch (error: any) {
      // TODO: blech:
      let message = error.msg || "Minting failed! Please try again!";
      if (!error.msg) {
        if (error.message.indexOf("0x138")) {
        } else if (error.message.indexOf("0x137")) {
          message = `SOLD OUT!`;
        } else if (error.message.indexOf("0x135")) {
          message = `Insufficient funds to mint. Please fund your wallet.`;
        }
      } else {
        if (error.code === 311) {
          message = `SOLD OUT!`;
          setIsSoldOut(true);
        } else if (error.code === 312) {
          message = `Minting period hasn't started yet.`;
        }
      }

      setAlertState({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      if (wallet) {
        const balance = await props.connection.getBalance(wallet.publicKey);
        setBalance(balance / LAMPORTS_PER_SOL);
      }
      setIsMinting(false);
    }
  };

  useEffect(() => {
    const mintStatus = localStorage.getItem('minted_status');
    if(mintStatus === 'succeeded'){
      setPresaleMintSucceeded(true);
    }
  }, [])

  useEffect(() => {
    (async () => {

      if(wallet){
        const walletId = wallet.publicKey.toBase58()
        if(whitelist.includes(walletId)){
          setIsWhitelisted(true);
        }
        else{
          setIsWhitelisted(false);
        }
      }
      
      if (wallet) {
        //console.log("wallet", wallet.publicKey.toBase58());
        //first time wallet is loaded - hide Mint button
        setTimeout(() => setMintButtonIsHidden(false), 2000); 
        const balance = await props.connection.getBalance(wallet.publicKey);
        setBalance(balance / LAMPORTS_PER_SOL);
      }
    })();

  }, [wallet, props.connection]);

  useEffect(() => {
    //every second rerender and check to see if startdate is active
    const interval = setInterval(() => {
      //check if current date is before start date and change isActive
      const nowDate = new Date(Date.now());
      const convertedStartDate = new Date(startDate); 
      if(nowDate < convertedStartDate){
        setIsActive(false);
      }
      else{
        setIsActive(true);
      };
    }, 1000);
    return () => clearInterval(interval);
  }, [startDate]);

  useEffect(() => {
    (async () => {
      if (!wallet) return;

      const { candyMachine, goLiveDate, itemsRemaining } =
        await getCandyMachineState(
          wallet as anchor.Wallet,
          props.candyMachineId,
          props.connection
        );          
      setItemsRemaining(itemsRemaining);
      setIsSoldOut(itemsRemaining === 0);
      setStartDate(goLiveDate);
      setCandyMachine(candyMachine);
    })();
  }, [wallet, props.candyMachineId, props.connection]);

  return (
    <main className="container max-w-4xl m-auto flex flex-col justify-center items-center">
      <link href="https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css" rel="stylesheet" /> 
      <link href="https://fonts.googleapis.com/css2?family=Roboto+Mono&display=swap" rel="stylesheet"></link>

      <div className="relative">
        <div className="absolute top-0 bottom-0 right-0 left-0 bg-gray-800 bg-opacity-40">
        </div>
        <div className="absolute top-0 bottom-0 right-0 left-0">
          <MintContainer className="flex flex-col items-center justify-center h-full">

            {wallet && (
              <div className="text-white text-4xl font-mono font-bold pb-6">{(itemsRemaining || 0).toLocaleString()}/1500</div>
            )}

            {!wallet ? (
              <ConnectButton className="button-style-1">Connect Wallet</ConnectButton>
            ) : (
              
              <MintButton
                disabled={isSoldOut || isMinting || !isActive || presaleMintSucceeded}
                onClick={onMint}
                variant="contained"
                className="button-style-1"
              >
                {isSoldOut ? (
                  "SOLD OUT"
                ) : !isWhitelisted ? (
                  <div>You are not whitelisted with this wallet.</div>
                )
                : presaleMintSucceeded ? (
                  <div>Congratulations!</div>
                )
                : mintButtonIsHidden ? (
                  <div>Loading...</div>
                )
                : isActive ? (
                  isMinting ? (
                    <CircularProgress />
                  ) : (
                    "MINT NOW"
                  )
                ) : (
                  <Countdown
                    date={startDate}
                    onMount={({ completed }) => completed && setIsActive(true)}
                    onComplete={() => setIsActive(true)}
                    renderer={renderCounter}
                  />
                )}
              </MintButton>
            )}
          </MintContainer>
        </div>
        <img alt="Banana background" className="border-8 border-gray-100" src="https://img.editmode.com/production/content_pieces/cnk_e29a3ebe50f0474de65d/2MRp54Lo2Luv/images/original/animated_avtar_28dfddf987abe87337183528df3b3fb4d804b397244a93b0b696470ccbd2b61f.gif" />

      </div> 

      {wallet && (
        <p className="mt-4">Your Address: {shortenAddress(wallet.publicKey.toBase58() || "")}</p>
      )}

      {wallet && (
        <p>Your Balance: {(balance || 0).toLocaleString()} SOL</p>
      )}


      <Snackbar
        open={alertState.open}
        autoHideDuration={6000}
        onClose={() => setAlertState({ ...alertState, open: false })}
      >
        <Alert
          onClose={() => setAlertState({ ...alertState, open: false })}
          severity={alertState.severity}
        >
          {alertState.message}
        </Alert>
      </Snackbar>
    </main>
  );
};

interface AlertState {
  open: boolean;
  message: string;
  severity: "success" | "info" | "warning" | "error" | undefined;
}

const renderCounter = ({ days, hours, minutes, seconds, completed }: any) => {
  return (
    <CounterText>
      {hours} hours, {minutes} minutes, {seconds} seconds
    </CounterText>
  );
};

export default Home;
